__turbopack_context__.v({
  "featuredQuantity": "addToCartMobile-module-scss-module__AiE2MW__featuredQuantity",
  "productCard": "addToCartMobile-module-scss-module__AiE2MW__productCard",
  "wrapper": "addToCartMobile-module-scss-module__AiE2MW__wrapper",
});
